export default __webpack_public_path__ + "static/media/chest-3.335151e6.webp";